<template>
  <div class="contrast-button" @click="toggleHighContrast()">
    <div class="contrast-button--label" v-if="label !== ''">
      {{ label }}
    </div>
    <div class="contrast-button--icon invert-on-highcontrast" :class="{ 'active': $store.getters.isHighContrastSelected }" />
  </div>
</template>

<script>
import { UIThemesEnum } from '../../../models/ui-themes.js'

export default {
  name: 'ContrastButton',
  props: {
    label: { default: '', type: String }
  },
  methods: {
    toggleHighContrast () {
      if (!this.$store.getters.isHighContrastSelected) {
        this.$store.commit('setUITheme', UIThemesEnum.HIGH_CONTRAST)
      } else {
        this.$store.commit('setUITheme', UIThemesEnum.DEFAULT)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/stylesheets/styleguide";

.contrast-button {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  cursor: pointer;
  .contrast-button--icon {
    width: 18px;
    height: 18px;
    background: url("~@/assets/images/icons/ic_adjust.svg") no-repeat;
    background-size: 100% 100%;
    &.active {
      transform: rotateZ(180deg);
    }
  }
}
</style>
